/* wc-comments.js — shared client for REAL storefront comments.
   Talks to the engine (api/comments) and layers real, persistent comments on top of
   each section's in-character seed comments. Sections render in their own style; this
   file only owns data (load / post / vote) + a couple of formatting helpers.

   window.WCComments.load(thread, sort)      -> Promise<[{id,name,body,ts,up,real}]>
   window.WCComments.post(thread, {name,body,cid}) -> Promise<{ok,comment}>
   window.WCComments.vote(thread, id)        -> Promise<{ok,up}>
   window.WCComments.esc(str) / .timeAgo(ts) / .threadId(str)
*/
(function () {
  var API = "https://api.weirdcastle.com/api/comments";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function threadId(s) {
    return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 63) || "general";
  }

  function timeAgo(ts) {
    var s = Math.max(1, Math.floor((Date.now() - ts) / 1000));
    if (s < 60) return "just now";
    var m = Math.floor(s / 60); if (m < 60) return m + (m > 1 ? " minutes ago" : " minute ago");
    var h = Math.floor(m / 60); if (h < 24) return h + (h > 1 ? " hours ago" : " hour ago");
    var d = Math.floor(h / 24); if (d < 7) return d + (d > 1 ? " days ago" : " day ago");
    var w = Math.floor(d / 7); if (w < 5) return w + (w > 1 ? " weeks ago" : " week ago");
    var mo = Math.floor(d / 30); if (mo < 12) return mo + (mo > 1 ? " months ago" : " month ago");
    return Math.floor(d / 365) + " years ago";
  }

  function load(thread, sort) {
    return fetch(API + "?thread=" + encodeURIComponent(threadId(thread)) + "&sort=" + (sort === "top" ? "top" : "new"))
      .then(function (r) { return r.json(); })
      .then(function (j) { return (j && j.items) || []; })
      .catch(function () { return []; });
  }

  function post(thread, payload) {
    return fetch(API, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Object.assign({ thread: threadId(thread) }, payload)),
    }).then(function (r) { return r.json(); }).catch(function () { return { ok: false }; });
  }

  function vote(thread, id) {
    return fetch(API, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "vote", thread: threadId(thread), id: id }),
    }).then(function (r) { return r.json(); }).catch(function () { return { ok: false }; });
  }

  window.WCComments = { load: load, post: post, vote: vote, esc: esc, timeAgo: timeAgo, threadId: threadId };
})();
